import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import NavbarForOnboardingForm from "../onboarding/NavbarForOnbardingForm";
import { useLoading } from "../LoadingContext";

function CopyAddUser() {
  const navigate = useNavigate();
  const { id } = useParams(); // Get the ID from the URL parameters

  const { loading, setLoading } = useLoading(true);
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    organization: "",
    designation: "",
    role: "",
  });

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    // Retrieve client ID and user ID from localStorage
    const storedClient = localStorage.getItem("client");

    const client_id = storedClient ? Number(storedClient) : null;

    // Debugging: Log retrieved values
    // console.log("Submitting JD with:", { client_id });

    if (!client_id) {
      alert("Client ID is missing. Please log in again.");
      return;
    }

    const apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/auth/admin-create-user/`; // Local Django server endpoint
    const headers = {
      "Content-Type": "application/json",
    };

    const UpdatedUserData = { ...userData, client: client_id };
    axios
      .post(apiEndpoint, UpdatedUserData, { headers })
      .then((response) => {
        // console.log(response.data);
        navigate("/user_confirmation");
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          alert(error.response.data.message);
        } else {
          alert("Failed to Add User");
        }
        console.error(error);
      });
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/auth/users/${id}/`)
      .then((response) => {
        setUserData({
          first_name: response.data.data.first_name || "",
          last_name: response.data.data.last_name || "",
          email: response.data.data.email || "",
          phone_number: response.data.data.phone_number || "",
          organization: response.data.data.organization || "",
          designation: response.data.data.designation || "",
          role: response.data.data.role || "",
        });
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setError(error);
        alert(error.response.data.message);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <div
        className="container d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div>
          <div
            className="spinner-border text-dark"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <h3 className="text-center text-dark">&nbsp;Data is Fetching.... </h3>
      </div>
    );
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      <NavbarForOnboardingForm />
      <div className="container py-5">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-10 col-md-8 col-lg-6 col-xl-5 log">
            <div className="card border border-dark bg-transparent text-dark">
              <div
                className="card-header border-dark text-white"
                style={{ background: "#008cba" }}
              >
                <h4 className="text-center font_header">Add User Form</h4>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <div data-mdb-input-init className="form-outline">
                          <label className="form-label" htmlFor="first_name">
                            First Name
                          </label>
                          <input
                            type="text"
                            id="first_name"
                            name="first_name"
                            className="form-control border-dark text-dark"
                            value={userData.first_name || ""} // Fallback to an empty string
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div data-mdb-input-init className="form-outline">
                          <label className="form-label" htmlFor="last_name">
                            Last Name
                          </label>
                          <input
                            type="text"
                            id="last_name"
                            name="last_name"
                            className="form-control border-dark text-dark"
                            value={userData.last_name || ""} // Fallback to an empty string
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="email" className="form-label">
                          Email address
                        </label>
                        <input
                          type="email"
                          className="form-control border-dark text-dark"
                          id="email"
                          name="email"
                          value={userData.email || ""} // Fallback to an empty string
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="phone_number" className="form-label">
                          Phone Number
                        </label>
                        <input
                          type="tel"
                          className="form-control border-dark text-dark"
                          id="phone_number"
                          name="phone_number"
                          pattern="(\+91)?[6-9][0-9]{9}"
                          value={userData.phone_number || ""} // Fallback to an empty string
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="organization" className="form-label">
                          Organization
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="organization"
                          name="organization"
                          value={userData.organization || ""} // Fallback to an empty string
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="designation" className="form-label">
                          Designation
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="designation"
                          name="designation"
                          value={userData.designation || ""} // Fallback to an empty string
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <label htmlFor="role" className="form-label">
                      Role
                    </label>
                    <input
                      type="text"
                      className="form-control border-dark text-dark"
                      id="role"
                      name="role"
                      aria-describedby="emailHelp"
                      value={userData.role || ""}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="text-center py-2">
                    <button type="submit" className="btn btn-outline-info me-2">
                      Submit
                    </button>
                    <button
                      className="btn btn-outline-danger"
                      type="button"
                      onClick={() => navigate("/user_dashboard")}
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CopyAddUser;
